import {FULFILLED} from 'redux-promise-middleware';
import {replace} from 'ramda';

import {CHECKOUT, LOCATION_CHANGED} from 'constants/actions';

import {call, select, takeEvery, fork} from 'redux-saga/effects';
import {getRouter} from 'selectors/router/router';

import htoCategoryAnalyticsSaga from './category/categoryAnalytics';
import htoProductAnalyticsSaga from './product/productAnalytics';
import {sendCheckoutAnalytics, htoCheckoutSaga} from './checkout/checkoutAnalytics';
import {sendThankPageAnalytics} from './thankYou/thankYouAnalytics';
import gtmVariableSaga from './gtm/gtm';
import gtmCheckoutAnalyticsSaga from './gtmCheckout/gtmCheckout';

/**
 * Emit events on location change
 */
export function* onLocationChanged() {
    const {location} = yield select(getRouter);
    const eventEmitters = {
        'checkout/onepage': sendCheckoutAnalytics,
    };
    const emitter = eventEmitters[replace(/^\/|\/$/g, '', location.pathname)];

    if (emitter) yield call(emitter);
}

/**
 * HTO analytics root saga
 */
export function* homeTryOnAnalyticsSaga() {
    yield takeEvery(LOCATION_CHANGED, onLocationChanged);
    yield takeEvery(`${CHECKOUT.SAVE_ORDER}_${FULFILLED}`, sendThankPageAnalytics);
    yield fork(htoProductAnalyticsSaga);
    yield fork(htoCategoryAnalyticsSaga);
    yield fork(gtmVariableSaga);
    yield fork(gtmCheckoutAnalyticsSaga);
    yield fork(htoCheckoutSaga);
}
